import { DtoBase } from '../../../shared/model/dtoBase.model';
export class ProfileCustomField extends DtoBase {
  public Id: number;
  public CustomFieldId: number;
  public FieldName: string;
  public ProfileId: number;
  public FieldValue: string;

  public constructor() {
    super();
    this.Id = 0;
    this.CustomFieldId = 0;
    this.FieldName = '';
    this.ProfileId = 0;
    this.FieldValue = '';
  }
}
